import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import { startOfToday, startOfYesterday, subDays } from "date-fns";
import { groupBy } from "lodash";

const CHAT_RECENCY_BUCKETS = [
  "today",
  "yesterday",
  "past_week",
  "past_30_days",
  "older",
] as const;

export type ChatRecencyBucket = (typeof CHAT_RECENCY_BUCKETS)[number];

const PAST_WEEK_DAYS = 7;
const PAST_30_DAYS = 30;

export const groupChatsByRecency = (chats: Chat[]) => {
  const todayStart = startOfToday();
  const yesterdayStart = startOfYesterday();
  const pastWeekStart = subDays(todayStart, PAST_WEEK_DAYS);
  const past30DaysStart = subDays(todayStart, PAST_30_DAYS);

  const recencyBucket = (chat: Chat): ChatRecencyBucket => {
    const activityAt = new Date(chat.last_message_at ?? chat.created_at);

    if (activityAt >= todayStart) return "today";
    if (activityAt >= yesterdayStart) return "yesterday";
    if (activityAt >= pastWeekStart) return "past_week";
    if (activityAt >= past30DaysStart) return "past_30_days";
    return "older";
  };

  const chatsByBucket = groupBy(chats, recencyBucket);

  return CHAT_RECENCY_BUCKETS.flatMap(bucket => {
    const bucketChats = chatsByBucket[bucket];
    return bucketChats ? [{ bucket, chats: bucketChats }] : [];
  });
};
